import { render, staticRenderFns } from "./UploadVideo.vue?vue&type=template&id=adb6ab02&scoped=true"
import script from "./UploadVideo.vue?vue&type=script&lang=js"
export * from "./UploadVideo.vue?vue&type=script&lang=js"
import style0 from "./UploadVideo.vue?vue&type=style&index=0&id=adb6ab02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb6ab02",
  null
  
)

export default component.exports